import { eventBus } from "@zhoujianhui/vip3-core";
export default {
  name: "RefreshRoute",
  methods: {
    refreshRoute() {
      eventBus.$emit("EVENT_RELOAD_ROUTER_VIEW");
    }
  }
};